import RGPD from "./Rgpd.jsx";

export default RGPD;
